import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError, BehaviorSubject, Observable, switchMap, concatMap, of, tap } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
    providedIn: 'root',
})
export class DriverService {
    // _liveApiUrl: any = this.authService._liveApiUrl;
    get _liveApiUrl() {
        return this.authService._liveApiUrl;
    }

    constructor(
        private http: HttpClient,
        public authService: AuthServiceService
    ) { }

    public _drivers = new BehaviorSubject<object[]>([]);
    private _activedrivers = new BehaviorSubject<object[]>([]);
    private _ndrivers = new BehaviorSubject<object[]>([]);
    public driversData: { drivers: object[] } = { drivers: [] };
    private activedriversData: { activedrivers: object[] } = { activedrivers: [] };
    private ndriversData: { ndrivers: object[] } = { ndrivers: [] };
    private mapdriversData: { mapdrivers: object[] } = { mapdrivers: [] };
    private _mapdrivers = new BehaviorSubject<object[]>([]);

    // Caching for Driver Listing
    public cachedDriverList: any[] = [];
    public cachedTabName: string = 'all';
    public cachedSearchQuery: string = '';
    public cachedCurrentPage: number = 1;
    public forceRefreshListing: boolean = false;

    getDrivers(): Observable<any[]> {
        return this._drivers.asObservable();
    }
    getactiveDrivers(): Observable<any[]> {
        return this._activedrivers.asObservable();
    }
    ngetDrivers(): Observable<any[]> {
        return this._ndrivers.asObservable();
    }
    getMapDrivers(): Observable<any[]> {
        return this._mapdrivers.asObservable();
    }

    driverAdd(form: any) {
        return this.http
            .post<any>(`${this._liveApiUrl}/account/add-driver/`, form)
            .pipe(
                map((data: any) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }

    deleteDocumentr(id: number) {
        return this.http.delete<any>(
            `${this._liveApiUrl}/account/delete-driver-document/${id}`
        );
    }
    driverEdit(id: Number, form: any) {
        return this.http
            .put<any>(`${this._liveApiUrl}/account/edit-driver/${id}`, form)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }

    driverActivateDeactivate(id: Number, status: any) {
        return this.http
            .put<any>(`${this._liveApiUrl}/account/activatedeactivate-driver/${id}`, status)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }

    driverDelete(id: Number) {
        return this.http.delete<any>(
            `${this._liveApiUrl}/account/delete-driver/${id}`
        );
    }

    convertBlobToBase64(blob: Blob) {
        return Observable.create((observer: any) => {
            const reader = new FileReader();
            const binaryString = reader.readAsDataURL(blob);
            reader.onload = (event: any) => {
                observer.next(event.target.result);
                observer.complete();
            };

            reader.onerror = (event: any) => {
                observer.next(event.target.error.code);
                observer.complete();
            };
        });
    }
    driverDetails(id: any) {
        return this.http.get<any>(
            `${this._liveApiUrl}/account/driver-details/${id}`
        );
    }

    driverList(id?: Number, page?: any, val?: any, searchVal?: any) {
        let tail = '';
        let status = '';

        if (id) {
            tail = `${id}`;
        }

        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        if (searchVal && searchVal.length > 0) {
            params.set('search_text', searchVal);
        }
        if (page && page !== 'all') {
            params.set('page', page + 1);
        } else if (page === 'all') {
            params.set('page', 'all');
        }


        // Only append query parameters if any exist
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {
                    if (data.errorMessage == 'Invalid page number') {
                        this.driverList(); return;
                    }

                    this.driversData.drivers = data;
                    this._drivers.next(Object.assign({}, this.driversData).drivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    ndriverList(
        id?: Number,
        page?: any,
        val?: any,
        searchVal?: any
    ): Observable<any> {

        let tail = '';
        let status = '';

        if (id) tail = `${id}`;

        if (val === "AD") status = "active";
        else if (val === "INAD") status = "inactive";
        else status = "";

        let params = new URLSearchParams();

        if (status) params.set('status', status);
        if (searchVal && searchVal.length > 0) params.set('search_text', searchVal);

        if (page && page !== 'all') {
            params.set('page', page);
            params.set('page_size', '10');
            params.set('page_limit', '10');
            params.set('limit', '10');
            params.set('per_page', '10');
        } else if (page === 'all') {
            params.set('page', 'all');
        }

        if (params.toString()) tail = `?${params.toString()}`;

        return this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${id ? id : ''}${tail}`)
            .pipe(
                switchMap((data: any) => {

                    if (data?.errorMessage === "Invalid page number" && page > 1) {

                        console.log("Invalid driver page detected, loading previous page...");

                        localStorage.setItem('DriverPage', String(page - 1));

                        return this.ndriverList(id, page - 1, val, searchVal);
                    }

                    return of(data);
                }),
                catchError(this.authService.handleError)
            );
    }




    reassigndriverList(id?: Number, page?: any, val?: any, searchVal?: any) {
        let tail = '';
        let status = '';

        if (id) {
            tail = `${id}`;
        }

        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        if (searchVal && searchVal.length > 0) {
            params.set('search_text', searchVal);
        }
        if (page) {
            params.set('page', page + 1);
        }

        // Only append query parameters if any exist
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        this.http.get<any>(`${this._liveApiUrl}/account/driver-listing/?status=active&page=all&reassign=true`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {
                    if (data.errorMessage == 'Invalid page number') {
                        this.driverList(); return;
                    }

                    this.driversData.drivers = data;
                    this._drivers.next(Object.assign({}, this.driversData).drivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    driverList1(val?: any) {
        let tail = '';
        let status = '';
        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        // Only append query parameters if any exist
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {
                    if (data.errorMessage == 'Invalid page number') {
                        this.driverList(); return;
                    }

                    this.driversData.drivers = data;
                    this._drivers.next(Object.assign({}, this.driversData).drivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    driverList19(val?: any) {
        let tail = '';
        let status = '';

        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }

        if (params.toString()) {
            tail = `?${params.toString()}`;
        }

        // 🔥 IMPORTANT: return the observable (DON’T SUBSCRIBE HERE)
        return this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    if (data.errorMessage == 'Invalid page number') {
                        return { invalidPage: true };
                    }
                    return data;
                }),
                catchError((error) => {
                    this.authService.dataError(error);
                    throw error;
                })
            );
    }

    driverList2(id?: Number, page?: any, val?: any, searchVal?: any) {
        let tail = '';
        let status = '';

        if (id) {
            tail = `${id}`;
        }

        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        if (searchVal && searchVal.length > 0) {
            params.set('search_text', searchVal);
        }
        if (!id) {
            params.set('page', 'all');
            params.set('status', "active");
            params.set('active_since_days', '7');
        }

        // Only append query parameters if any exist
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {
                    if (data.errorMessage == 'Invalid page number') {
                        this.driverList(); return;
                    }

                    this.driversData.drivers = data;
                    this._drivers.next(Object.assign({}, this.driversData).drivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    driverList3(id?: Number, page?: any, val?: any, searchVal?: any): Observable<any> {
        let tail = '';
        let status = '';

        if (id) {
            tail = `${id}`;
        }

        if (val === "TD") {
            status = "";
        } else if (val === "AD") {
            status = "active";
        } else if (val === "INAD") {
            status = "inactive";
        }

        let params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        if (searchVal && searchVal.length > 0) {
            params.set('search_text', searchVal);
        }
        if (!id) {
            params.set('page', 'all');
            params.set('status', "active");
            params.set('active_since_days', '7');
        }

        // Only append query parameters if any exist
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        return this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                tap((data: any) => {
                    if (data.errorMessage == 'Invalid page number') {
                        this.driverList();
                        return;
                    }

                    this.mapdriversData.mapdrivers = data;
                    this._mapdrivers.next(Object.assign({}, this.mapdriversData).mapdrivers);
                }),
                catchError((error) => {
                    this.authService.dataError(error);
                    throw error;
                })
            );
    }
    /**
     * Fetch driver locations for the Locate Driver screen.
     * Uses the new /account/driver-locations/ API which includes running_order data.
     */
    getDriverLocations(driverId?: string): Observable<any> {
        let url = `${this._liveApiUrl}/account/driver-locations/`;
        if (driverId) {
            url += `?driver_id=${driverId}`;
        }
        return this.http
            .get<any>(url)
            .pipe(
                catchError((error) => {
                    this.authService.dataError(error);
                    throw error;
                })
            );
    }

    activeDriverList() {
        let params = new URLSearchParams();

        // Set the status to "active"
        params.set('status', 'active');

        // Add the page parameter if it exists

        params.set('page', 'all');


        // Append query parameters if any exist
        let tail = '';
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        // HTTP GET request for active drivers only
        this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {

                    // Update driver data and emit via BehaviorSubject
                    this.driversData.drivers = data;
                    this._drivers.next(Object.assign({}, this.driversData).drivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }
    activeDriverList1() {
        let params = new URLSearchParams();

        // Set the status to "active"
        params.set('status', 'active');

        // Add the page parameter if it exists

        params.set('page', 'all');


        // Append query parameters if any exist
        let tail = '';
        if (params.toString()) {
            tail += `?${params.toString()}`;
        }

        // HTTP GET request for active drivers only
        this.http
            .get<any>(`${this._liveApiUrl}/account/driver-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
            .subscribe(
                (data: any) => {

                    // Update driver data and emit via BehaviorSubject
                    this.activedriversData.activedrivers = data;
                    this._activedrivers.next(Object.assign({}, this.activedriversData).activedrivers);
                },
                (error) => {
                    this.authService.dataError(error);
                }
            );
    }


    getDriverssCount() {
        return this.http.get<any>(`${this._liveApiUrl}/company/driver-status-counts/`).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.authService.handleError)
        );
    }

    driverOrders(id: any) {
        let tail = '';
        if (id) {
            tail = `${id}`;
        }
        return this.http.get<any>(`${this._liveApiUrl}/company/driver-orders/${tail}`)
    }

    orderCount(driverId?: any, today_date?: any) {
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (driverId && driverId.length > 0) {
                params.set('driver_id', driverId),
                    params.set('driver_today_orders', 'true')
                params.set('today_date', today_date)
            }
        }
        if (driverId) {
            tail += `?` + params.toString();
        }
        return this.http
            .get<any>(`${this._liveApiUrl}/company/order-counts/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
    }
    orderHistory(driverId?: any) {
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (driverId && driverId.length > 0) {
                params.set('driver_id', driverId)
            }
        }
        if (driverId) {
            tail += `?` + params.toString();
        }
        return this.http
            .get<any>(`${this._liveApiUrl}/company/order-history/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
    }
    orderNotification(driverId?: any) {
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (driverId && driverId.length > 0) {
                params.set('driver_id', driverId)
            }
        }
        if (driverId) {
            tail += `?` + params.toString();
        }
        return this.http
            .get<any>(`${this._liveApiUrl}/notification/get-driver-recent-notification/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
    }
    orderDetailViewAll(id: any, activeTab: any, currentPage: any) {
        if (activeTab === 'tripHistory') {
            const driver_id = Number(id.replace(/\D/g, ''));
            // const numericPart = ids.replace(/\D/g, '');
            // const idNumber = parseInt(numericPart, 10);
            console.log(driver_id);
            return this.http
                .get<any>(`${this._liveApiUrl}/company/order-history/?driver_id=${driver_id}&page=${currentPage}`)
                .pipe(
                    map((data) => {
                        return data;
                    }),
                    catchError(this.authService.handleError)
                );

        }
        else if (activeTab === 'notification') {
            const driver_id = Number(id.replace(/\D/g, ''));
            // const numericPart = ids.replace(/\D/g, '');
            // const idNumber = parseInt(numericPart, 10);
            console.log(driver_id);
            return this.http
                .get<any>(`${this._liveApiUrl}/notification/get-driver-recent-notification/?driver_id=${driver_id}&page=${currentPage}`)
                .pipe(
                    map((data) => {
                        return data;
                    }),
                    catchError(this.authService.handleError)
                );
        }
        return
    }
    orderList(driver_id?: any, order_status?: any, order_date?: any, page?: any, driver_today_orders?: any, order_id?: any) {
        let tail = '';
        let params = new URLSearchParams();

        if (order_date && order_date.length > 0) {
            params.set('order_date', order_date);
        }
        if (order_status && order_status.length > 0) {
            params.set('order_status', order_status);
            // Set driver_today_orders to 'true' if order_status is 'pending'
            if (order_status === 'pending') {
                params.set('driver_today_orders', 'true');
            }
        }
        if (driver_today_orders) {
            params.set('driver_today_orders', driver_today_orders);
        }
        if (driver_id) {
            params.set('driver_id', driver_id);
            // params.set('driver_today_orders', 'true');
        }
        if (page) {
            params.set('page', (page + 1).toString());
        }
        if (order_id) {
            params.set('order_id', order_id);
        }

        if (order_date || order_status || driver_id || page || order_id) {
            tail += `?` + params.toString();
        }

        return this.http
            .get<any>(`${this._liveApiUrl}/company/order-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }

    orderListing(driver_id?: any, page?: any) {
        let tail = '';
        let params = new URLSearchParams();
        if (params) {
            if (driver_id) {
                params.set('driver_id', driver_id),
                    params.set('driver_today_orders', 'true')
            }
        }
        if (driver_id) {
            tail += `?` + params.toString();
        }
        return this.http
            .get<any>(`${this._liveApiUrl}/company/order-listing/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            )
    }

    sendNotificationToGroup(formData: any) {
        return this.http
            .post<any>(`${this.authService._liveApiUrl}/notification/send-driver-notification/`, formData)

    }
    orderNotificationAll(driverId?: any) {
        let tail = '';
        let params = new URLSearchParams();

        if (params) {
            if (driverId && driverId.length > 0) {
                params.set('driver_id', driverId);
            }

            // 🔥 New parameter added
            params.set('page', 'all');
        }

        if (params.toString()) {
            tail += `?` + params.toString();
        }

        return this.http
            .get<any>(`${this._liveApiUrl}/notification/get-driver-recent-notification/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }
    tripHistoryAll(driverId?: any) {
        let tail = '';
        let params = new URLSearchParams();

        if (params) {
            if (driverId && driverId.length > 0) {
                params.set('driver_id', driverId);
            }

            // 🔥 New parameter added
            params.set('page', 'all');
        }

        if (params.toString()) {
            tail += `?` + params.toString();
        }

        return this.http
            .get<any>(`${this._liveApiUrl}/company/order-history/${tail}`)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError(this.authService.handleError)
            );
    }

}
